/**
 * Build a linked summary dynamically from the current inline field errors.
 * An optional preceding element keeps introductory content above the summary;
 * otherwise it is inserted at the top of the form's field column.
 */
export function summarizeErrors(root, afterElement = null) {
  root.querySelector('[data-member-error-summary]')?.remove();
  const errors = Array.from(root.querySelectorAll('.fui-error-messages'));
  if (!errors.length) return;

  const summary = document.createElement('div');
  summary.dataset.memberErrorSummary = '';
  summary.className = 'member-form-error-summary';
  summary.setAttribute('role', 'alert');
  const heading = document.createElement('p');
  heading.textContent = 'Please correct the following before continuing:';
  summary.append(heading);
  const list = document.createElement('ul');
  errors.forEach((error) => {
    const control = Array.from(root.querySelectorAll('[aria-invalid="true"]'))
      .find((input) => (input.getAttribute('aria-describedby') || '').split(/\s+/).includes(error.id));
    const item = document.createElement('li');
    const button = document.createElement('button');
    button.type = 'button';
    const field = error.closest('[data-field-handle], .fui-field');
    const label = field?.querySelector('label, legend')?.textContent?.replace(/\s*\*\s*$/, '').trim();
    button.textContent = `${label ? label + ': ' : ''}${error.textContent.trim()}`;
    button.addEventListener('click', () => {
      const target = control || error;
      if (!control) target.setAttribute('tabindex', '-1');
      target.focus({preventScroll: true});
      target.scrollIntoView({behavior: 'smooth', block: 'center'});
    });
    item.append(button);
    list.append(item);
  });
  summary.append(list);
  if (afterElement) {
    afterElement.after(summary);
  } else {
    (root.querySelector('.row-wrapper') || root).prepend(summary);
  }
}
